import { normalize } from 'normalizr'

import * as auth from '../auth'
import { jsonPost } from 'api'

export const updateAccount = (token, details, recaptchaToken) => {
    const {
        salutation,
        firstName,
        lastName,
        phone,
        billingAddress,
        deliveryAddress = billingAddress,
        custom1,
        custom2,
        emailAddress,
        document: { type: documentType, number: documentNumber } = {},
    } = details

    return jsonPost(`${GRS_ACCOUNTS_SERVICE}/CreateAccount`, {
        LAZAccountDetail: {
            ParkingIndividualDetail: {
                Id: 0,
                Salutation: salutation,
                FirstName: firstName,
                LastName: lastName,
                Phone: phone,
                EmailAddress: emailAddress,
                Address1: billingAddress.address1,
                Address2: billingAddress.address2,
                City: billingAddress.city,
                State: billingAddress.state,
                PostalCode: billingAddress.postalCode,
                Country: billingAddress.country,
                Billing_FirstName: billingAddress.firstName,
                Billing_LastName: billingAddress.lastName,
                Billing_Address1: billingAddress.address1,
                Billing_Address2: billingAddress.address2,
                Billing_City: billingAddress.city,
                Billing_State: billingAddress.state,
                Billing_PostalCode: billingAddress.postalCode,
                Billing_Country: billingAddress.country,
                Billing_District: billingAddress.district,
                Billing_Number: billingAddress.streetNumber,
                DeliveryName: deliveryAddress.firstName,
                DeliveryAddress: deliveryAddress.address1,
                DeliveryAddress2: deliveryAddress.address2,
                DeliveryCity: deliveryAddress.city,
                DeliveryState: deliveryAddress.state,
                DeliveryPostCode: deliveryAddress.postalCode,
                DeliveryCountry: deliveryAddress.country,
                DeliveryDistrict: deliveryAddress.district,
                DeliveryNumber: deliveryAddress.streetNumber,
                VehicleDetail: [],
                Custom1: custom1,
                Custom2: custom2,
                CustomerDocumentType: documentType,
                CustomerDocumentNumber: documentNumber,
            },
            AccountCardDetail: [],
            Token: token,
            'g-recaptcha-response': recaptchaToken,
        },
    })
        .then(response => normalize(response, auth.schemas.userSchema))
        .catch(error => {
            throw new Error(error.message)
        })
}
